import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import {
  CreateBakIntegrationsSuccessResponse,
  CreateBakIntegrationsErrorResponse,
  CreateBakIntegrationsPayload,
  createBakIntegrationsApi,
} from 'IntegrationModule/api/createBakIntegrationsApi';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import { useNotification } from 'hooks/useNotification';

export const useCreateBakIntegration = () => {
  const token = useSelector(selectAuthToken);
  const { showSuccess, showError } = useNotification();

  const mutation = useMutation<
    AxiosResponse<CreateBakIntegrationsSuccessResponse>,
    AxiosResponse<CreateBakIntegrationsErrorResponse>,
    CreateBakIntegrationsPayload
  >({
    mutationFn: async (params) => {
      if (!token) {
        throw new Error('No auth token available');
      }
      return createBakIntegrationsApi({ params, token }) as Promise<
        AxiosResponse<CreateBakIntegrationsSuccessResponse>
      >;
    },
    onSuccess: (response) => {
      // ✅ FIX: Replace alert() with toast notification
      if (response.data?.message) {
        showError(`Provision bak Integration failed! ${response.data?.message}`);
      } else {
        showSuccess('Provision bak Integration successful!');
      }
    },
    onError: (error) => {
      // ✅ FIX: Replace alert() with toast notification
      showError(`Provision bak Integration failed! ${error.data.message}`);
    },
  });
  return {
    createBakIntegration: mutation.mutate,
    isCreatingBakIntegration: mutation.isPending,
  };
};
